import styled from '@emotion/styled';

export const ErrorAlert = styled.div`
  background-color: var(--colour-molten-tint);
  color: var(--colour-red);
  padding: var(--spacing-300);
  margin-bottom: var(--spacing-300);
  border-radius: var(--border-radius-tiny);
`;
